var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"invite-bulk"},[_c('label',[_vm._v("Enter Email Addresses")]),_vm._v(" "),_c('textarea',{ref:"text",attrs:{"placeholder":"Please separate email addresses with space, comma or semicolon."},on:{"keyup":_vm.getEmails}})])}
var staticRenderFns = []

export { render, staticRenderFns }